import { Text } from '@radix-ui/themes';
import { useMediaState } from '@vidstack/react';
import { useSmartPlayerContext } from '../context/SmartPlayerContext';
import { formatTimecode } from '../utils/timecode';

export const SmartPlayerTimecode = () => {
    const currentTime = useMediaState('currentTime');
    const duration = useMediaState('duration');

    const { fps } = useSmartPlayerContext();

    return (
        <Text
            size='2'
            weight='medium'
            style={{
                fontVariantNumeric: 'tabular-nums',
                color: 'var(--gray-11)',
                letterSpacing: '0.5px',
            }}
        >
            <Text style={{ color: 'white' }}>
                {formatTimecode(currentTime, fps)}
            </Text>
            {' / '}
            {formatTimecode(duration, fps)}
        </Text>
    );
};
